
import React from 'react';
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import style from '../CustomViewTask.module.css';

interface TaskFieldRowProps {
  icon: string;
  label: string;
  value: React.ReactNode;
  loading?: boolean;
  iconWidth?: number;
  iconHeight?: number;
  valueComponent?: 'text' | 'chip';
  chipProps?: {
    backgroundColor?: string;
    color?: string;
    labelColor?: string;
  };
}

export const TaskFieldRow: React.FC<TaskFieldRowProps> = ({
  icon,
  label,
  value,
  loading = false,
  iconWidth,
  iconHeight,
  valueComponent = 'text',
  chipProps,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
      <img
        src={icon}
        className={style['field-icon']}
        width={iconWidth}
        height={iconHeight}
        style={{ objectFit: 'fill' }}
      />
      <Typography
        variant='responsiveBody2'
        color={zeplinColor.Neutral8}
        sx={{ flex: 1 }}
      >
        {label}
      </Typography>

      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            flex: 1,
          }}
        />
      ) : valueComponent === 'chip' ? (
        <Box sx={{ flex: 1 }}>
          {typeof value === 'string' ? (
            <Chip
              label={
                <Typography
                  variant='responsiveLabel1'
                  color={chipProps?.labelColor || zeplinColor.Neutral1}
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {value}
                </Typography>
              }
              sx={{
                backgroundColor: chipProps?.backgroundColor || zeplinColor.BasicBlack,
                color: chipProps?.color || zeplinColor.Neutral1,
                padding: '5px 14px 5px 14px',
                borderRadius: '50px',
                height: '29px',
                '&.MuiChip-root': {},
                '& .MuiChip-label ': {
                  padding: 0,
                },
              }}
            />
          ) : (
            value
          )}
        </Box>
      ) : (
        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
          {value}
        </Typography>
      )}
    </Box>
  );
};
